import { yupResolver } from "@hookform/resolvers/yup";
import { Typography, Stack, IconButton, TextField, Grid, Autocomplete, Button, } from "@mui/material"
import { CloseIcon } from "components/Icons"
import SaveIcon from '@mui/icons-material/SaveOutlined'
import { BasePathProvider } from "components/Providers"
import { Controller, useForm } from "react-hook-form";
import * as yup from 'yup'
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { saveSchool } from "store/application/student-applications";
import { useEffect } from "react";
import { search } from "store/application/application-setting";


function AddSchoolForm({ applicationRecord, setOpenDrawer, setApplicationRecord, clientSchools }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  // const { clients: clientList } = useSelector(state => state.lookup);
  // const clientSchools = clientList?.map(item => item.client?.schools).flat().filter(Boolean) || [];

  const schools = useSelector(state => state.application.applicationSetting.list);

  useEffect(() => {
    if (!schools) dispatch(search());
  }, [schools, dispatch]);

  const existingSchoolIds = applicationRecord?.applicationSchools?.map(a => a.school?.id) || [];
  const availableSchools = clientSchools.filter(s => !existingSchoolIds.includes(s.id));

  const schema = yup.object().shape({});

  const { control, handleSubmit } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      applicationSchool: null,
    },
  });

  const onSubmit = async (data) => {
    const selectedSchool = data.applicationSchool;

    if (!selectedSchool) return;

    const payload = {
      applicationId: applicationRecord.id,
      schoolId: selectedSchool.id,
    };

    try {
      const res = await dispatch(saveSchool(payload));

      if (res.payload) {
        setApplicationRecord(prev => ({
          ...prev,
          ...res.payload,
        }));
        setOpenDrawer(false);
      } else {
        console.error('Save failed:', res);
      }
    } catch (error) {
      console.error('Save error:', error);
    }
  };

  return (
    <BasePathProvider value={() => setOpenDrawer(false)}>
      <Stack sx={{ p: 2, borderBottom: '1px solid', borderColor: 'divider' }} direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h6" fontWeight={300}>
          {`Add School for ${applicationRecord?.firstName} ${applicationRecord?.lastName}`}
        </Typography>
        <IconButton aria-label="close" onClick={() => setOpenDrawer(false)}>
          <CloseIcon />
        </IconButton>
      </Stack>

      <Grid container spacing={1.5} sx={{ p: 2 }} component="form" onSubmit={handleSubmit(onSubmit)}>
        <Grid item xs={12}>
          <Controller
            name="applicationSchool"
            control={control}
            render={({ field, fieldState }) => (
              <Autocomplete
                options={availableSchools}
                getOptionLabel={(option) => option?.name || ""}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                value={field.value}
                onChange={(_, newValue) => field.onChange(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t("Select School")}
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                    size="small"
                    fullWidth
                  />
                )}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button type="submit" variant="contained" startIcon={<SaveIcon />}>
            {t('Submit')}
          </Button>
        </Grid>
      </Grid>
    </BasePathProvider>
  );
}

export default AddSchoolForm;
